import React from 'react'
import Navbar from './Navbar'
import Adsense from './Adsense'

function Contestrule() {
  return (
    <>
        <div className="main">
        <div className="main-div2">
      <div className="container mt-3">
        <div className="">
              <Navbar />
            </div>
            <div className='mt-5'>
                <h3 className='text-center'>Contest Rules!</h3>
                <div className='mt-4'>
                    <ul className='d-flex flex-column gap-3'>
                        <li>The winners for each quiz will be declared based on the scores they obtain during the participation in the quiz.</li>
                        <li>There will be a fixed time for declaring the winners of each quiz.</li>
                        <li>You will have overall 120 seconds to solve as many as questions from 10 questions in quiz.</li>
                        <li>There will be 4 options given below each question and one will be the answer for it out of them.</li>
                        <li>Each right answer fetches you 100 points.</li>
                        <li>Each wrong answer gives you (-) 100 points.</li>
                    </ul>
                </div>
            </div>

             {/* <div className='mb-5'>
            <Adsense slot="6300978111"/>
            </div> */}
      </div>
      </div>
      </div>
    </>
  )
}

export default Contestrule
